import type { Template } from "@/types";

export const PO_04_H1_V3: Template[] = [
{
    id: "po-04-h1v3-01",
    name: "PO 01 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 43, y: 256, width: 212, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 263, y: 256, width: 474, height: 337, rotation: 0, imageRotation: 0 },
            { id: "3", x: 745, y: 256, width: 212, height: 337, rotation: 0, imageRotation: 0 },
            { id: "4", x: 965, y: 256, width: 211, height: 337, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-04-h1v3-02",
    name: "PO 02 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "2", x: 100, y: 105, width: 408, height: 642, rotation: 0, imageRotation: 0 },
            { id: "1", x: 709, y: 105, width: 408, height: 322, rotation: 0, imageRotation: 0 },
            { id: "3", x: 709, y: 434, width: 201, height: 312, rotation: 0, imageRotation: 0 },
            { id: "4", x: 917, y: 434, width: 200, height: 312, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-03",
    name: "PO 03 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 35, y: 0, width: 539, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 678, y: 85, width: 461, height: 320, rotation: 0, imageRotation: 0 },
            { id: "3", x: 678, y: 413, width: 226, height: 352, rotation: 0, imageRotation: 0 },
            { id: "4", x: 912, y: 413, width: 226, height: 352, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-04",
    name: "PO 04 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 41, y: 256, width: 477, height: 337, rotation: 0, imageRotation: 0 },
        { id: "2", x: 526, y: 256, width: 212, height: 337, rotation: 0, imageRotation: 0 },
        { id: "3", x: 746, y: 256, width: 211, height: 337, rotation: 0, imageRotation: 0 },
        { id: "4", x: 965, y: 256, width: 211, height: 337, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-05",
    name: "PO 05 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 95, y: 117, width: 204, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 307, y: 117, width: 204, height: 327, rotation: 0, imageRotation: 0 },
            { id: "3", x: 95, y: 451, width: 416, height: 282, rotation: 0, imageRotation: 0 },
            { id: "4", x: 688, y: 69, width: 448, height: 711, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-06",
    name: "PO 06 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_06.png",
    size: [1217, 851],
    style: {},
    slots: [    
        { id: "1", x: 47, y: 290, width: 166, height: 270, rotation: 0, imageRotation: 0 },
        { id: "2", x: 221, y: 290, width: 166, height: 270, rotation: 0, imageRotation: 0 },
        { id: "3", x: 395, y: 290, width: 165, height: 270, rotation: 0, imageRotation: 0 },
        { id: "4", x: 655, y: 246, width: 514, height: 360, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-07",
    name: "PO 07 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 39, y: 256, width: 210, height: 330, rotation: 0, imageRotation: 0 },
            { id: "2", x: 256, y: 146, width: 315, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 256, y: 373, width: 210, height: 330, rotation: 0, imageRotation: 0 },
            { id: "4", x: 674, y: 0, width: 542, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-08",
    name: "PO 08 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 84, y: 192, width: 152, height: 229, rotation: 0, imageRotation: 0 },
        { id: "2", x: 84, y: 429, width: 152, height: 228, rotation: 0, imageRotation: 0 },
        { id: "3", x: 244, y: 192, width: 306, height: 465, rotation: 0, imageRotation: 0 },
        { id: "4", x: 558, y: 192, width: 574, height: 465, rotation: 0, imageRotation: 0 }
       
    ],
},

{
    id: "po-04-h1v3-09",
    name: "PO 09 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_09.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 43, y: 256, width: 211, height: 337, rotation: 0, imageRotation: 0 },
        { id: "2", x: 262, y: 256, width: 211, height: 337, rotation: 0, imageRotation: 0 },
        { id: "3", x: 481, y: 256, width: 211, height: 337, rotation: 0, imageRotation: 0 },
        { id: "4", x: 700, y: 256, width: 477, height: 337, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-10",
    name: "PO 10 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 59, y: 72, width: 919, height: 708, rotation: 0, imageRotation: 0 },
        { id: "2", x: 986, y: 72, width: 149, height: 231, rotation: 0, imageRotation: 0 },
        { id: "3", x: 986, y: 311, width: 149, height: 231, rotation: 0, imageRotation: 0 },
        { id: "4", x: 986, y: 550, width: 149, height: 230, rotation: 0, imageRotation: 0 }
    ],
}
];